export default __webpack_public_path__ + "static/media/GPA_Aug_Banner.4c030a35.jpg";